<template>
  <div class="mv-bg-main" style="overflow: scroll;">
    <div slot="header" class="header clearfix">
      <img src="../../assets/logo.png" class="homeImg" alt="">
      <div class="person">
        <div style="color: #303133">早安，Rabbit，祝您开心每一天</div>
        <div style="color: #606266; margin-top: 10px;">运营专员   小视科技-运营事业本部-系统运营组</div>
      </div>
      <div class="project">
        <div class="inline">
          <div style="color: #606266">项目数</div>
          <div class="center">6</div>
        </div>
        <div class="inline border">
          <div style="color: #606266">成员</div>
          <div class="center">6</div>
        </div>
        <div class="inline">
          <div style="color: #606266">访问数</div>
          <div class="center">666</div>
        </div>
      </div>
    </div>
    <el-card >
      <div class="mini-container">
        <div class="mini-main">
          <el-card>
            <div slot="header" class="clearfix">
              <span>卡片名称</span>
              <el-button style="float: right; padding: 3px 0" type="text">全部项目</el-button>
            </div>
            <div class="proMangement">
              <ul class="proUl" >
                <li class="proLi" v-for="(item, $index) in proList" :key="$index"></li>
              </ul>
            </div>
          </el-card>
          <el-card>
            <div slot="header" class="clearfix">
              <span>卡片名称</span>
              <el-button style="float: right; padding: 3px 0" type="text">更多动态</el-button>
            </div>
            <div>
              <ul class="dynamicUl" >
                <li class="dynamicLi" v-for="(item, $index) in dynamicList" :key="$index">{{item.detail}}</li>
              </ul>
            </div>
          </el-card>
        </div>
        <div class="mini-main-aside">
          <el-card>
            <div slot="header" class="clearfix">
              <span>快捷导航</span>
              <el-button style="float: right; padding: 3px 0" type="text">添加</el-button>
            </div>
            <div >
              <el-tag
                v-for="tag in tags"
                :key="tag.name"
                closable
                :type="tag.type">
                {{tag.name}}
              </el-tag>
            </div>
          </el-card>
          <el-card>
            <div slot="header" class="clearfix">
              <span>团队成员</span>
            </div>
          </el-card>
        </div>
      </div>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.mr {
  margin: 10px;
}
.proUl {
  box-sizing: border-box;
  overflow: hidden;
  box-sizing: border-box;
  padding: 10px;
}
.dynamicLi {
  width: 100%;
  height: 50px;
}
.proLi {
  border: 1px solid #DCDFE6;
  width: 30%;
  height: 80px;
  min-width: 200px;
  box-sizing: border-box;
  margin: 10px;
  float: left;
}
.proMangement {
}
.mini-main {
  display: flex;
  flex-direction: column;
  flex: 2;
  box-sizing: border-box;
}
.mini-container {
  display: flex;
  flex-direction: row;
  height: 100%;
  flex: 1;
  box-sizing: border-box;
}
.mini-main-aside {
  flex: 1;
  box-sizing: border-box;
  margin-left: 10px;
}
.center {
  text-align: center;
  color: #303133;
  margin-top: 10px;
}
.inline {
  display: inline-block;
  padding: 0 20px;
}
.border {
  border-left: 1px solid #DCDFE6;
  border-right: 1px solid #DCDFE6;
}
.homeImg {
  float: left;
}
.person {
  float: left;
  margin-left: 20px;
}
.project {
  float: right;
}
.header{
  padding: 18px 20px;
  border-bottom: 1px solid #ebeef5;
  box-sizing: border-box;
  background-color: #fff;
}
</style>
<script>
export default {
  name: 'homeManagement',
  data () {
    return {
      proList: [
        {},
        {},
        {},
        {},
        {},
        {}
      ],
      tags: [
        { name: '标签一', type: '' },
        { name: '标签二', type: 'success' },
        { name: '标签三', type: 'info' },
        { name: '标签四', type: 'warning' },
        { name: '标签五', type: 'danger' }
      ],
      dynamicList: [
        {
          detail: ' 2019-01-01 12:12:12   林东冬  对   BOSS--计价管理--修改计价管理   进行了操作新增了计价规则   张二噶的计费'
        },
        {
          detail: ' 2019-01-01 12:12:12   林东冬  对   BOSS--计价管理--修改计价管理   进行了操作新增了计价规则   张二噶的计费'
        }
      ]
    }
  },
  filters: {
    status (val) { // 状态转化
      let status = ''
      if (val === 1) {
        status = '待办'
      } else if (val === 2) {
        status = '进行中'
      } else {
        status = '已完成'
      }
      return status
    }
  },
  created () {
    this.query()
  },
  methods: {
    query () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/views/home/homeManagement.vue